// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"6843":"225fbf490f158314a6be","8003":"d6eacd5622b153d390cd"}[chunkId] + ".css";
};